import { gql } from '@apollo/client';

export type DashboardProjectUser = {
  id: string;
  name: string;
  email: string;
  role: string;
  avatarUrl?: string | null;
  firstName?: string | null;
  surname?: string | null;
};

export type DashboardProjectContext = {
  id: string;
  name: string | null;
  apiKey: string;
  organizationId: string;
  assignGuests: boolean;
  createTagsViaNewTask: boolean;
  screenshotServerUrl: string;
  domains: string[];
  devurl: string | null;
  users: DashboardProjectUser[];
  usersNotOnProject: DashboardProjectUser[];
  tags: { id: string; name: string; active: boolean; taskCount?: number | null }[];
  columns: {
    id: string;
    name: string | null;
    position: number | null;
    statusId: string | null;
    complete: boolean | null;
    projectId: string;
  }[];
  sites: { id: string; url: string; coverUrl?: string | null }[];
  owner: { id: string; name: string; email: string } | null;
  connectedIntegrations: Record<string, unknown>[];
  harvestIntegration: { id: number | null };
};

export type DashboardProjectAccess = {
  taskEditAssignees: boolean;
  taskViewAssignees: boolean;
  taskEditTags: boolean;
  taskEditDueDate: boolean;
  taskViewDueDate: boolean;
  taskEditSeverity: boolean;
  manageProject: boolean;
  editTaskUrl: boolean;
  taskViewSelector: boolean;
  taskEditComment: boolean;
  viewPrivateComments: boolean;
  createPrivateComments: boolean;
  viewCommitComment: boolean;
  taskDelete: boolean;
  taskMoveToProject: boolean;
  taskEditStatus: boolean;
  assignGuestsAllowed: boolean;
  taskMobileScreenshot: boolean;
  attachmentsDisabled: boolean;
  billing: boolean;
  viewLinkedTasks: boolean;
  sidebarViewStatuses: boolean;
  taskEditVisibility: boolean;
  guestsSeeGuestsAllowed: boolean;
  guestsSeeGuests: boolean;
};

export type DashboardProjectContextData = {
  currentUser: {
    id: string;
    accessTo: DashboardProjectAccess;
    userProject: DashboardProjectContext | null;
  };
};

export type DashboardProjectContextVars = {
  projectId: string;
  organizationId: string;
  apiKey: string;
};

export const GET_DASHBOARD_PROJECT_CONTEXT = gql`
  query getDashboardProjectContext(
    $projectId: ID!
    $organizationId: ID!
    $apiKey: String!
  ) {
    currentUser {
      id
      accessTo(organizationId: $organizationId, apiKey: $apiKey) {
        taskEditAssignees
        taskViewAssignees
        taskEditTags
        taskEditDueDate
        taskViewDueDate
        taskEditSeverity
        manageProject
        editTaskUrl
        taskViewSelector
        taskEditComment
        viewPrivateComments
        createPrivateComments
        viewCommitComment
        taskDelete
        taskMoveToProject
        taskEditStatus
        assignGuestsAllowed
        taskMobileScreenshot
        attachmentsDisabled
        billing
        viewLinkedTasks
        sidebarViewStatuses
        taskEditVisibility
        guestsSeeGuestsAllowed
        guestsSeeGuests
      }
      userProject(id: $projectId) {
        id
        name
        apiKey
        organizationId
        assignGuests
        createTagsViaNewTask
        screenshotServerUrl
        domains
        devurl
        owner {
          id
          name
          email
        }
        users {
          id
          name
          email
          role
          avatarUrl
          firstName
          surname
        }
        usersNotOnProject {
          id
          name
          email
          role
        }
        tags {
          id
          name
          active
          taskCount
        }
        columns {
          id
          name
          position
          statusId
          complete
          projectId
        }
        sites {
          id
          url
          coverUrl
        }
        connectedIntegrations
        harvestIntegration
      }
    }
  }
`;
